import {
  TOOL_CALL_PROGRESS_ERROR_STAGE,
  type ToolCallProgressEvent,
} from '@terra/shared-dto-chat-types';

export type ToolCallActivityRow = {
  id: string;
  label: string;
  summary?: string;
  content?: string;
  isError?: boolean;
};

export function toDetailFirstActivityRow(
  event: ToolCallProgressEvent,
): ToolCallActivityRow {
  return {
    id: event.id,
    label: event.detail || event.stage,
    isError: event.stage === TOOL_CALL_PROGRESS_ERROR_STAGE,
  };
}

export function toStageWithDetailActivityRow(
  event: ToolCallProgressEvent,
): ToolCallActivityRow {
  return {
    id: event.id,
    label: event.stage,
    summary: event.detail,
    isError: event.stage === TOOL_CALL_PROGRESS_ERROR_STAGE,
  };
}

const RESULT_SUMMARY_MAX_LENGTH = 60;
const ANALYZING_RESULT_STAGE_PATTERN = /^Analyzing .+ result$/;

function toFirstLineSummary(detail: string): string {
  const [firstLine = ''] = detail.split('\n');

  if (firstLine.length <= RESULT_SUMMARY_MAX_LENGTH) {
    return firstLine;
  }

  return `${firstLine.slice(0, RESULT_SUMMARY_MAX_LENGTH)}…`;
}

export function toCodeAnalyzerActivityRow(
  event: ToolCallProgressEvent,
): ToolCallActivityRow {
  const isError = event.stage === TOOL_CALL_PROGRESS_ERROR_STAGE;
  const detail = event.detail?.trim();
  const showsInlineSummary =
    !!detail && (isError || ANALYZING_RESULT_STAGE_PATTERN.test(event.stage));

  return {
    id: event.id,
    label: event.stage,
    summary: showsInlineSummary ? toFirstLineSummary(detail) : undefined,
    content: detail || undefined,
    isError,
  };
}

export function collapseConsecutiveDuplicateActivityRows(
  rows: ToolCallActivityRow[],
): ToolCallActivityRow[] {
  return rows.filter((row, index) => {
    const previous = rows[index - 1];

    return (
      !previous ||
      previous.label !== row.label ||
      previous.summary !== row.summary ||
      previous.content !== row.content ||
      previous.isError !== row.isError
    );
  });
}
